import { InformalFeedbackRequestNotification } from '../../types'
import { BaseNotificationItem } from '../../BaseNotificationItem'
import { informalFeedbackRequestPath, articleOrLayerPath } from '../../utils'
import { iconForNotification } from './utils'

interface Props {
  notification: InformalFeedbackRequestNotification
  onClose: () => void
}

export const ReviewCreatedNotification = (props: Props) => {
  const { notification } = props
  const reviewType = notification.subject.review_type
  const path =
    reviewType === 'read_receipt'
      ? articleOrLayerPath({ notification })
      : informalFeedbackRequestPath({ notification, submit: true })

  const title = () => {
    if (notification.subject.is_suggestion) return 'suggested changes'

    switch (reviewType) {
      case 'approval':
        return 'asked you to approve this file'
      case 'read_receipt':
        return 'asked you to mark this file as read'
      case 'review':
      default:
        return 'asked you to review this file'
    }
  }

  const ariaLabel = () => {
    if (notification.subject.is_suggestion) return 'Suggestion'

    switch (reviewType) {
      case 'approval':
        return 'Approval'
      case 'read_receipt':
        return 'Read Receipt'
      case 'review':
      default:
        return 'Review'
    }
  }

  return (
    <BaseNotificationItem
      {...props}
      title={title()}
      icon={iconForNotification(notification)}
      path={path}
      aria-label={`${ariaLabel()} Created Notification`}
    />
  )
}
